<template>
  <div class="login_container">
    <div class="login_box">

      <!-- Logo区 -->
      <div class="logo_area">
        <img src="../assets/logo.png" />
        <h2>Create Account</h2>
        <p>Join EvaJudge Platform</p>
      </div>

      <!-- 表单 -->
      <el-form
        ref="registerFormRef"
        :model="registerForm"
        :rules="registerRules"
        class="register_form"
        label-width="0px"
      >
        <el-form-item prop="email">
          <el-input
            v-model="registerForm.email"
            prefix-icon="iconfont icon-youxiang"
            placeholder="Institution Email"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="registerForm.password"
            prefix-icon="iconfont icon-mima"
            show-password
            placeholder="Password"
          />
        </el-form-item>

        <el-form-item prop="confirmPassword">
          <el-input
            v-model="registerForm.confirmPassword"
            prefix-icon="iconfont icon-mima"
            show-password
            placeholder="Confirm Password"
          />
        </el-form-item>

        <el-form-item class="btns">

          <el-button type="primary" class="main_btn" @click="enroll">
            Sign up
          </el-button>

          <div class="extra">
            <span @click="logout">Back to Login</span>
            <span @click="resetRegisterForm">Reset</span>
          </div>

        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registerForm: {
        email: "",
        password: "",
        confirmPassword: "",
      },

      registerRules: {
        email: [
          { required: true, message: "Please enter your personal institution email", trigger: "blur" },
          { type: "email", message: "Please enter a valid email address", trigger: ["blur", "change"] }
        ],

        password: [
          { required: true, message: "Please enter your password", trigger: "blur" },
          { min: 8, max: 19, message: "Password must be 8 to 19 characters long", trigger: "blur" },
        ],

        confirmPassword: [
          { required: true, message: "Please confirm your password", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) {
                callback(new Error("Passwords do not match"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    resetRegisterForm() {
      this.$refs.registerFormRef.resetFields();
    },

    logout() {
      this.$router.push("/login");
    },

    async enroll() {
      this.$refs.registerFormRef.validate(async valid => {
        if (!valid) return;

        const email = this.registerForm.email;
        const password = this.registerForm.password;

        // ⭐ 2. 立即跳转（关键！！！）
        this.$router.push({
          path: "/verify-email",
          query: { email }
        });

        // ⭐ 3. 后台慢慢注册（不阻塞 UI）
        try {
          const res = await this.$http.post("/register", {
            email,
            password
          });

          // 可以提示（但此时已经在验证页了）
          this.$message.success("Verification code sent");

        } catch (error) {
          const msg =
            error.response?.data?.msg || "Registration failed";

          this.$message.error(msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>

/* ===== 页面整体 ===== */
.login_container {
  height: 100%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== 卡片 ===== */
.login_box {
  width: 380px;
  padding: 40px 40px 30px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
}

/* ===== Logo区 ===== */
.logo_area {
  text-align: center;
  margin-bottom: 30px;

  img {
    width: 48px;
    margin-bottom: 10px;
  }

  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f2a44;
  }

  p {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7280;
  }
}

/* ===== 输入框 ===== */
.el-input__inner {
  border-radius: 6px;
}

/* ===== 主按钮 ===== */
.main_btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
  background: linear-gradient(90deg, #3fae9a, #6fd1c2);
  border: none;
}

/* ===== 底部操作 ===== */
.extra {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 12px;
  color: #6b7280;

  span {
    cursor: pointer;
  }

  span:hover {
    color: #3fae9a;
  }
}

/* ===== 按钮区 ===== */
.btns {
  display: flex;
  flex-direction: column;
}

/* ===== 图标 ===== */
.iconfont {
  color: #9ca3af;
}

</style>